class CartDrawer extends HTMLElement {
  constructor() {
    super();
    // Esc no document: o foco pode estar fora do drawer (ex.: depois de um re-render)
    document.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape' && this.classList.contains('active')) this.close();
    });
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;

    const pbContainer = this.querySelector('.goal-progress--drawer');
    const fill = this.querySelector('.goal-progress__bar-fill');
    if (fill) fill.style.width = '0%';

    this.classList.add('active');

    requestAnimationFrame(() => {
      const overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay) {
        overlay.style.opacity = '1';
        overlay.style.pointerEvents = 'auto';
      }

      requestAnimationFrame(() => {
        this.classList.add('animate');

        if (pbContainer && fill) {
          const applyFill = (total) => {
            const threshold = parseInt(pbContainer.dataset.threshold || '0');
            if (threshold > 0) {
              fill.style.width = Math.min((total / threshold) * 100, 100) + '%';
            }
          };

          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              pbContainer.dataset.total = cart.total_price;
              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'drawer-open', cartData: cart });
              } else {
                applyFill(cart.total_price);
              }
            })
            .catch(() => {
              applyFill(parseInt(pbContainer.dataset.total || '0'));
            });
        }

        this.addEventListener(
          'transitionend',
          () => {
            const container = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer');
            // o 1º .drawer__close é o do estado vazio, que fica oculto quando há itens
            const closeBtn = Array.from(container.querySelectorAll('.drawer__close')).find((el) => el.offsetParent);
            trapFocus(container, closeBtn || container);
          },
          { once: true }
        );
      });
    });
    document.body.classList.add('overflow-hidden');
  }

  close() {
    // Overlay: ocultar com transição
    const overlay = document.getElementById('CartDrawer-Overlay');
    if (overlay) {
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
    }

    this.classList.remove('animate');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    // só a transição do painel (#CartDrawer.cart-drawer, não as que sobem dos filhos),
    // e só se ninguém reabriu o drawer nesse meio tempo
    const onEnd = (event) => {
      if (event.target.id !== 'CartDrawer' || event.propertyName !== 'transform') return;
      this.removeEventListener('transitionend', onEnd);
      if (!this.classList.contains('animate')) this.classList.remove('active');
    };
    this.addEventListener('transitionend', onEnd);
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
